import { urlService } from 'core-utilities';
import { entityUrl } from 'core-roblox-utilities';
import placeListsLayout from '../../gameLists/constants/placeListsLayout';

const getGameReferralUrl = (
  game,
  pageType,
  index,
  sortName,
  pageContext,
  sortPosition,
  dateTime,
  gameDetailPlaceId
) => {
  const { placeId, nativeAdData } = game;
  const referralData = {
    PageType: pageType,
    PlaceId: placeId,
    Position: index + 1
  };

  switch (pageType) {
    case placeListsLayout.pageTypes.gameDetail:
      referralData.RecommendationSourceId = gameDetailPlaceId;
      referralData.RecommendationAlgorithm = 2; // TODO: need to sync up game search && discovery team to figure out how to get that
      break;
    default:
      break;
  }

  if (nativeAdData) {
    referralData.NativeAdData = nativeAdData;
  }
  if (sortName) {
    referralData.SortName = sortName;
  }

  if (pageContext?.pageId) {
    referralData.PageId = pageContext?.pageId;
  }
  if (sortPosition > -1) {
    referralData.SortPosition = sortPosition + 1;
  }
  let gameReferralUrl = urlService.getUrlWithQueries(
    entityUrl.game.getReferralPath(),
    referralData
  );
  // url service encode timestamp, just be sure no impact for event data collection, so manually append here
  const currentDateTime = dateTime || new Date().toISOString();
  gameReferralUrl = `${gameReferralUrl}&LocalTimestamp=${currentDateTime}`;
  return gameReferralUrl;
};

export default {
  getGameReferralUrl
};
